import React, { useEffect, useState } from "react";
import ReviewWrapperNOCU from "../../../../components/wrappers/reviewWrapper";
import ToggleButtonSet from "../../../../components/buttons/ToggleButtonSet";
import FileButtonSet from "../../../../components/buttons/FileButtonSet";
import { APPROVED, DEFAULT } from "../../../../Helpers/constants";
import DynamicStepper, { createStepper } from "../../../../components/stepper/dynamicStepper";
import { EXPORTER_ROUTES } from "../../../../app/router/routes";
import { navigateSelf } from "../../../../app/router/routerManager";
import {
	getApplicationDetails,
	submitApplicationDetails,
} from "../../../../app/api/NOCU/applicationAPI";
import { getFileURL } from "../../../../app/api/file_api";
import { STATUS } from "../../../../app/constants";
import {
	deleteAllApplicationRejectDetails,
	getApplicationRejectDetailsAll,
} from "../../../../Helpers/rejectionHelpers";
import { getRejctionsByStep } from "../../../../app/api/NOCU/rejectionAPI";
import { getApplicationStage } from "../../../../components/table/tableHelpers";
import {
	appendRejectionsFiles,
	appendRejectionsSingleForm,
	validateFiles,
} from "../dataManipulation";

const ExporterStep1 = ({
	stepperData,
	stepperName,
	routeArray,
	setIsLoading,
	nextCustomRoute,
	customIndex,
	readOnly,
	hideFiles,
	hideBtns,
}) => {
	const [businessDetail, setBusinessDetail] = useState();
	const [form, setForm] = useState();
	const [rejections, setRejections] = useState();
	const [isDisabled, setDisabled] = useState(true);
	const [_files, _setFiles] = useState([
		{ name: "BRC", path: "", status: DEFAULT, comment: "" },
		{ name: "TIN", path: "", status: DEFAULT },
		{ name: "VAT", path: "", status: DEFAULT },
	]);
	const [canApprove, setCanApprove] = useState(false);
	const [reviewStatus, setReviewStatus] = useState();

	console.log("Stepperr", stepperData);

	useEffect(() => {
		deleteAllApplicationRejectDetails();
		getApplicationDetails(1)
			.then((res) => {
				setReviewStatus(res?.stepStatus);
				setBusinessDetail(res?.businessDetailRequest);
			})
			.catch((e) => {
				console.log(e);
			})
			.finally(() => {
				getRejctionsByStep(1)
					.then((res) => {
						setRejections(res.data);
						console.log("Rejection ======>", res);
					})
					.then((e) => {
						console.log(e);
					})
					.finally(() => {
						setIsLoading(false);
					});
			});
	}, []);

	useEffect(() => {
		form &&
			rejections &&
			appendRejectionsSingleForm(
				rejections?.rejectReasonDetailList,
				form,
				setForm,
				businessDetail?.entityId
			);

		_files &&
			rejections &&
			appendRejectionsFiles(
				rejections?.rejectReasonDetailList,
				_files,
				_setFiles,
				businessDetail?.entityId
			);
	}, [rejections]);

	useEffect(() => {
		_setFiles([
			{
				name: "BRC",
				path: getFileURL(businessDetail?.brnFilePath),
				status: reviewStatus === "PENDING" ? DEFAULT : APPROVED,
				comment: "",
			},
			{
				name: "TIN",
				path: getFileURL(businessDetail?.tinFilePath),
				status: reviewStatus === "PENDING" ? DEFAULT : APPROVED,
				comment: "",
			},
			{
				name: "VAT",
				path: getFileURL(businessDetail?.vatFilePath),
				status: reviewStatus === "PENDING" ? DEFAULT : APPROVED,
				comment: "",
			},
		]);
		setForm([
			{
				name: "destinationOfProducts",
				label: "Destination of Products",
				value: businessDetail?.destinationOfProducts,
				isChecked: true,
				disable: true,
			},
			{
				name: "companyName",
				label: "Name of Company",
				value: businessDetail?.companyName,
				isChecked: true,
				disable: false,
			},
			{
				name: "businessAddress",
				label: "Business Address",
				value: businessDetail?.businessAddress,
				isChecked: true,
				disable: false,
			},
			{
				name: "district",
				label: "District",
				value: businessDetail?.district,
				isChecked: true,
				disable: false,
			},
			{
				name: "divisionalSecretariat",
				label: "Divisional Secretariat",
				value: businessDetail?.divisionalSecretariat,
				isChecked: true,
				disable: false,
			},
			{
				name: "gramaNiladhariDivision",
				label: "Grama Niladhari Division",
				value: businessDetail?.gramaNiladhariDivision,
				isChecked: true,
				disable: false,
			},
			{
				name: "tin",
				label: "TIN",
				value: businessDetail?.tin,
				isChecked: true,
				disable: false,
			},
			{
				name: "vat",
				label: "VAT",
				value: businessDetail?.vat,
				isChecked: true,
				disable: false,
			},
			{
				name: "companyRegNumberType",
				label: "Type of Business Registration",
				value: businessDetail?.companyRegNumberType,
				isChecked: true,
				disable: false,
			},
			{
				name: "companyRegNumber",
				label: "Company Registration No",
				value: businessDetail?.companyRegNumber,
				isChecked: true,
				disable: false,
			},
			{
				name: "companyRegDate",
				label: "Company Registration Date",
				value: businessDetail?.companyRegDate,
				isChecked: true,
				disable: false,
			},
			{
				name: "companyPlaceofReg",
				label: "Place of Business  Registration",
				value: businessDetail?.companyPlaceofReg,
				isChecked: true,
				disable: false,
			},
			{
				name: "typeOfBusiness",
				label: "Business Registration Type",
				value: businessDetail?.typeOfBusiness,
				isChecked: true,
				disable: false,
			},
			{
				name: "processingPlantAddress",
				label: "Address of Processing Plant / Warehouse",
				value: businessDetail?.processingPlantAddress,
				isChecked: true,
				disable: false,
			},
			{
				name: "website",
				label: "Website",
				value: businessDetail?.website,
				isChecked: true,
				disable: false,
			},
			{
				name: "edbRegNumber",
				label: "EDB Registration Number",
				value: businessDetail?.edbRegNumber,
				isChecked: true,
				disable: false,
			},
		]);
	}, [businessDetail, reviewStatus]);
	const [selectedFile, setSelectedFile] = useState();
	const nameArray = [{ name: "Suran Mendis" }, { name: "Sudesh Kumara" }, { name: "Ruwan Perera" }];

	useEffect(() => {
		console.log("Files ============>", _files);
	}, [_files]);
	useEffect(() => {
		console.log("Selected File ============>", selectedFile?.path);
	}, [selectedFile]);

	const handleNext = () => {
		deleteAllApplicationRejectDetails();
		navigateSelf(EXPORTER_ROUTES.STEP02);
	};
	const handleCUstomNext = (route) => {
		navigateSelf(route);
	};

	const closeApplication = () => {
		deleteAllApplicationRejectDetails();
		navigateSelf(EXPORTER_ROUTES.HOME + "/1");
	};
	const handleResubmit = (comments) => {
		setIsLoading(true);
		console.log("Resubmit Comments", comments);
		submitApplicationDetails(
			1,
			STATUS.RESUBMIT,
			comments,
			getApplicationRejectDetailsAll(),
			false,
			[],
			getApplicationStage(),
			null,
			rejections?.reasonId
		)
			.then((res) => {
				handleNext();
			})
			.catch((e) => console.log(e));
	};
	const handleSubmit = () => {
		setIsLoading(true);
		submitApplicationDetails(
			1,
			STATUS.APPROVED,
			"",
			getApplicationRejectDetailsAll(),
			false,
			[],
			getApplicationStage(),
			null,
			rejections?.reasonId
		)
			.then((res) => {
				handleNext();
			})
			.catch((e) => console.log(e));
	};
	const handleReject = (comments) => {
		setIsLoading(true);
		console.log("Reject Comments", comments);
		submitApplicationDetails(
			1,
			STATUS.REJECTED,
			comments,
			getApplicationRejectDetailsAll(),
			false,
			[],
			getApplicationStage(),
			null,
			rejections?.reasonId
		)
			.then((res) => {
				closeApplication();
			})
			.catch((e) => console.log(e));
	};
	const updateFileArray = (updatedFiles) => {
		_setFiles(updatedFiles);
	};

	useEffect(() => {
		if (form && _files) {
			const dataFalseValue = form.some((item) => !item.isChecked);
			const filesFalseValue = _files.some((item) => item.status == "REJECTED");
			if (dataFalseValue || filesFalseValue) setDisabled(false);
			else setDisabled(true);
		}
	}, [form, _files]);

	const handleResubmitDisable = (data, files) => {
		const dataFalseValue = data.some((item) => !item.isChecked);
		const filesFalseValue = files.some((item) => item.status == "REJECTED");

		if (dataFalseValue || filesFalseValue) setDisabled(false);
		else setDisabled(true);
	};

	useEffect(() => {
		_files && validateFiles(_files) ? setCanApprove(true) : setCanApprove(false);
		console.log("Wrapper Files=====>", _files);
	}, [_files]);

	return (
		<div>
			<ReviewWrapperNOCU
				hideBtns={hideBtns}
				readOnly={readOnly}
				index={customIndex || 0}
				entityId={businessDetail?.entityId}
				title={"Business Details"}
				setForm={setForm}
				stepperName={stepperName}
				files={_files}
				isDisabled={isDisabled}
				// formToggleSwitch={<ToggleButtonSet data={nameArray} handleClick={handlePerson} />}
				topBar={
					stepperData &&
					stepperName && (
						<DynamicStepper name={stepperName} stepperData={stepperData} routeArray={routeArray} />
					)
				}
				formData={form}
				currentFile={selectedFile}
				fileButtons={
					!!!hideFiles && (
						<FileButtonSet
							hideBtns={hideBtns}
							files={_files}
							readOnly={readOnly}
							setFiles={_setFiles}
							selectedFile={selectedFile}
							updateFileArray={updateFileArray}
							setSelectedFile={setSelectedFile}
							entityId={businessDetail?.entityId}
							setDisabled={handleResubmitDisable}
							formData={form}
						/>
					)
				}
				handleReject={handleReject}
				handleResubmit={handleResubmit}
				handleNext={handleSubmit}
				setDisabled={handleResubmitDisable}
				canApprove={canApprove}
				reviewed={
					nextCustomRoute ? () => handleCUstomNext(nextCustomRoute) : readOnly ? handleNext : null
				}
			/>
		</div>
	);
};

export default ExporterStep1;
